require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-afdb-has-approved-new-safeguards-but-is-it-ready-to.json") })
        }
      }, "path---en-us-update-afdb-has-approved-new-safeguards-but-is-it-ready-to");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-afdb-has-approved-new-safeguards-but-is-it-ready-to!./.cache/json/en-us-update-afdb-has-approved-new-safeguards-but-is-it-ready-to.json
// module id = 608
// module chunks = 231608221292675